module.exports = __webpack_public_path__ + "media/img/ms-icon-150x150-f71ff02822f8e9d260fa6e1ce94e41fd.png";